import { Link as ExternalLink } from "@trussworks/react-uswds";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import DirectionsLink from "../ResultDetail/DirectionsLink";
import { getMilesFromMeters } from "../../utils/filters/distance";
import Badge from "../Badge";
import { ReactComponent as BadgeCheck } from "../../images/badge-check.svg";
import { ReactComponent as Telehealth } from "../../images/telehealth.svg";
import CallProviderLink from "../ResultDetail/CallProviderLink";
import { V1Clinic } from "../../types/v1_schemas";

function CompareDetail({ data, zip }: { data: V1Clinic; zip: string | null }) {
  const { t } = useTranslation();

  return (
    <div className="display-flex height-full flex-column">
      <div className="margin-bottom-3 display-none tablet:display-flex flex-wrap">
        {data.newPatientAcceptance && (
          <Badge
            bgColor="blue"
            Icon={<BadgeCheck />}
            text={t("acceptingNewPatients")}
            showTooltip
            tooltipText={t("acceptingNewPatientsNote")}
          />
        )}
        {data.clinicTelehealthOption && data.clinicTelehealthOption!.lineageText !== "No Telehealth Available" && (
          <Badge
            bgColor="yellow"
            Icon={<Telehealth height={13} />}
            text={t("telehealthAvailable")}
          />
        )}
      </div>
      <div className="margin-bottom-3 flex-fill">
        {data.clinicPhones && (
          <>
            <h3 className="usa-sr-only">{t("telephoneNumber")}</h3>
            <ExternalLink
              variant="external"
              href={`tel:${data.clinicPhones[0].phone}`}
            >
              {data.clinicPhones[0].phone}
            </ExternalLink>
          </>
        )}
        {(!!data.clinicLocations?.length || !!data.clinicTelehealthOption) && (
          <>
            <h3 className="usa-sr-only">{t("address")}</h3>
            <div>
              {data.clinicLocations?.length &&
              data.clinicLocations[0].addressLine1?.length
                ? data.clinicLocations.filter(f => !!f.latitude && !!f.latitude)
                  .map((addr, idx) => (
                    <Fragment key={idx}>
                      {addr.addressLine1}
                      <br />
                      {(!!addr.addressLine2 && 
                      <>
                        {addr.addressLine2}
                        <br />
                      </>)}
                      {addr.cityText}, {addr.stateText} {addr.postalCode}
                    </Fragment>
                  ))
                : t("telehealthOnlyAddress")}
            </div>
          </>
        )}
      </div>
      {data.distanceInMiles && (
        <div className="margin-bottom-1">
          {t("milesAwayFrom", {
            miles: getMilesFromMeters(data.distanceInMiles).toFixed(1),
            zip,
          })}
        </div>
      )}
      {data.latLng && data.clinicLocations?.length ? (
        <DirectionsLink v1Clinic={data} />
      ) : (
        <CallProviderLink v1Clinic={data} />
      )}
    </div>
  );
}

export default CompareDetail;
